import "./cancellation-order-details.scss";
import "../account-order-card/account-order-card.scss";
import "../order-line-item/order-line-item.scss";

const initExpandButtons = () => {
  const expandButtons = document.querySelectorAll(".js-faq-icon");

  expandButtons.forEach(button => {
    button.addEventListener("click", e => {
      const details = e.target.closest(".cancellation-order-details-shipment");
      const lineItemsId = details.id.split("-")[1];
      const lineItemsDiv = document.getElementById(`line-items-${lineItemsId}`);

      lineItemsDiv.classList.toggle("hidden");

      const buttonDiv = e.target.closest(".cancellation-order-details-shipment__expand_buttons");
      buttonDiv.querySelector(".plus-icon").classList.toggle("hidden");
      buttonDiv.querySelector(".minus-icon").classList.toggle("hidden");
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initExpandButtons();
});
